"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _ = require("../../");

var _Constant = require("../../Constant");

var _Button = _interopRequireDefault(require("../../Button"));

var _TwoColumnMenuIcons = require("./TwoColumnMenuIcons");

var _hooks = require("../../hooks");

var _theme, _theme2;

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-right: 0.8rem;\n  color: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    margin-left: 30px;\n    min-width: auto;\n    padding: 12px 30px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  text-decoration: none;\n  margin: 0;\n  outline: none;\n  vertical-align: middle;\n  display: inline-block;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration-color: currentcolor;\n    text-decoration-line: underline;\n  }\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    ", "\n    outline-offset: 2px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n\n  @media print, screen and (min-width: ", "px) {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  ", ", ", " {\n    @media print, screen and (min-width: ", "px) {\n      padding: 0 30px;\n      border-right: ", ";\n      font-size: 1.2rem;\n      color: ", ";\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      font-size: 1.3rem;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &&& {\n    @media print, screen and (min-width: ", "px) {\n      border-right: none;\n      padding-right: 10px;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: ", ";\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 10px 20px;\n  border-bottom: 1px solid ", ";\n  height: 60px;\n\n  @media print, screen and (min-width: ", "px) {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var menuLogo = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, "".concat(_Constant.Color.CALIBER_GREEN, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "".concat(_Constant.Color.BLACK_SOUL)), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, "".concat(_Constant.Color.BLACK, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, "".concat(_Constant.Color.HOMEPOINT_NAVY, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, "".concat(_Constant.Color.YELLOW, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, "".concat(_Constant.Color.YELLOW, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, "".concat(_Constant.Color.YELLOW, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";")), _theme));
var focusStyles = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.CALIBER, "outline: 1px solid ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, "outline: 1px solid ".concat(_Constant.Color.HOMEBRIDGE_YELLOW_LIGHT)), (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEPOINT, "outline: 1px solid ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, "outline: 1px solid ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.FIGURE, "outline: 1px solid ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.PETERSENDEAN, "outline: 1px solid ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.PELLA, "outline: 1px solid ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, "outline: 1px solid ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY, ";")), _theme2));
var stateColors = (0, _styledTheming.default)('mode', (0, _defineProperty2.default)({
  figure: _Constant.Color.FOCUS_B,
  pella: _Constant.Color.FOCUS_B,
  petersendean: _Constant.Color.FOCUS_B
}, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.FOCUS_B));

var Telephone = _styledComponents.default.div(_templateObject());

var Container = _styledComponents.default.header(_templateObject2(), function (_ref) {
  var hasChildren = _ref.hasChildren;
  return hasChildren ? 'flex' : 'none';
}, _Constant.Color.BUBBLE_GREY, _Constant.Width.MD);

var Dropdown = (0, _styledComponents.default)(_.Dropdown)(_templateObject3(), _Constant.Width.MD);

var Navbar = _styledComponents.default.nav(_templateObject4(), _Constant.Width.MD, Telephone, Dropdown, _Constant.Width.MD, function (_ref2) {
  var noBorder = _ref2.noBorder;
  return !noBorder && "1px solid ".concat(_Constant.Color.BUBBLE_GREY);
}, _Constant.Color.MEDIUM_GREY, _Constant.Width.LG); // TODO: Extend from SmallAnchor when the menu styles are being updated. State styles can be removed at that point.


var TelLink = _styledComponents.default.a(_templateObject5(), stateColors, focusStyles);
/**
 * In Storybook, these extended styles are overridden by the default Button styles.
 * This does not happen when testing against a product, so it seems to be Storybook-specific.
 * Just to be safe, I'm adding the `&&` to double the class and make sure these styles are applied.
 */


var Button = (0, _styledComponents.default)(_Button.default)(_templateObject6());

var MenuWrapper = _styledComponents.default.span(_templateObject7(), menuLogo);

var TwoColumnMainMenu = function TwoColumnMainMenu(_ref3) {
  var menuList = _ref3.menuList,
      children = _ref3.children,
      phoneNumber = _ref3.phoneNumber,
      isRegistration = _ref3.isRegistration,
      linkRoute = _ref3.linkRoute,
      linkText = _ref3.linkText,
      isLogin = _ref3.isLogin,
      handleRegister = _ref3.handleRegister;

  // Utilize breakpoints here to determine if the container should render as a section or header. This is important to provide accurate landmarks for assistive technology users
  var _useBreakpoints = (0, _hooks.useBreakpoints)(),
      breakpoint = _useBreakpoints.breakpoint;

  var isMobile = breakpoint === _Constant.Breakpoint.SM || breakpoint === _Constant.Breakpoint.XS;
  return menuList.length > 0 ? /*#__PURE__*/_react.default.createElement(Container, {
    as: isMobile ? 'section' : 'header',
    "aria-label": isMobile ? 'CEO-feedback' : null,
    hasChildren: !!children
  }, children || /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement(Navbar, {
    noBorder: isRegistration
  }, /*#__PURE__*/_react.default.createElement(Telephone, null, /*#__PURE__*/_react.default.createElement(TelLink, {
    href: "tel:".concat(phoneNumber)
  }, /*#__PURE__*/_react.default.createElement(_TwoColumnMenuIcons.TelephoneIcon, null), "Have a question? ", phoneNumber)), !isRegistration ? /*#__PURE__*/_react.default.createElement(Dropdown, {
    ariaLabelledbyId: "dropdown-menu",
    toggleButton: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        display: 'inline-flex',
        flexDirection: 'row',
        verticalAlign: 'middle',
        fontWeight: '700'
      }
    }, /*#__PURE__*/_react.default.createElement(MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_TwoColumnMenuIcons.MenuIcon, null)), "Menu"),
    menuStyle: {
      top: '2.5rem',
      right: '0'
    },
    menuList: menuList
  }) : !isLogin ? /*#__PURE__*/_react.default.createElement(Button, {
    semanticElement: "a",
    href: linkRoute
  }, linkText) : /*#__PURE__*/_react.default.createElement(Button, {
    onClick: handleRegister
  }, linkText))) : /*#__PURE__*/_react.default.createElement(Container, {
    as: isMobile ? 'section' : 'header',
    "aria-label": isMobile ? 'CEO-feedback' : null,
    hasChildren: !!children
  }, children || /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement(Navbar, {
    noBorder: true
  }, /*#__PURE__*/_react.default.createElement(Telephone, null, /*#__PURE__*/_react.default.createElement(TelLink, {
    href: "tel:".concat(phoneNumber)
  }, /*#__PURE__*/_react.default.createElement(_TwoColumnMenuIcons.TelephoneIcon, null), "Have a question? ", phoneNumber))));
};

TwoColumnMainMenu.propTypes = {
  menuList: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  children: _propTypes.default.node,
  phoneNumber: _propTypes.default.string,
  isRegistration: _propTypes.default.bool,
  linkRoute: _propTypes.default.string,
  linkText: _propTypes.default.string,
  isLogin: _propTypes.default.bool,
  handleRegister: _propTypes.default.func
};
TwoColumnMainMenu.defaultProps = {
  children: null,
  phoneNumber: '1-888-819-6388',
  isRegistration: false,
  linkRoute: null,
  linkText: null,
  isLogin: false,
  handleRegister: function handleRegister() {}
};
var _default = TwoColumnMainMenu;
exports.default = _default;